import React from "react";
import Icon from "./Icon";
import { categoryKey, formatDate, reviewSteps, statusCaption, statusLabel, statusOf } from "./proposalsModel";

export function CategoryTag({ category }) {
  if (!category) return null;
  return <span className="tag cat" style={{ "--c": `var(--color-cat-${categoryKey(category)})` }}><i />{category}</span>;
}

export function StatusTag({ status }) {
  const icon = status === "pending" ? "clock" : status === "approved" ? "check" : null;
  return <span className={`tag ${status}`}>{icon && <Icon n={icon} s={11} />}{statusLabel(status)}</span>;
}

export function CategoryTile({ category }) {
  return <span className="tile" style={{ "--c": `var(--color-cat-${categoryKey(category)})` }} aria-hidden="true"><Icon n="doc" s={20} /></span>;
}

function Track({ sub }) {
  const steps = reviewSteps(sub);
  if (!steps.length) return null;
  return (
    <div className="trk" aria-label="Review progress">
      {steps.map((step, i) => (
        <React.Fragment key={step.key}>
          {i > 0 && <span className={`ln${steps[i - 1].state === "done" && step.state !== "todo" ? " done" : ""}`} />}
          <span className={`st ${step.state}`}>
            <i>{step.state === "done" || step.state === "good" ? <Icon n="check" s={11} /> : step.state === "bad" ? <Icon n="x" s={11} /> : null}</i>
            {step.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

/**
 * One proposal in the list. The whole row opens the detail dialog; the action buttons stop propagation.
 * `onSchedule`, `onWithdraw` and `onRevise` receive the submission.
 */
export default function ProposalRow({ sub, onOpen, onSchedule, onWithdraw, onRevise }) {
  const status = statusOf(sub);
  const stop = (fn) => (e) => { e.stopPropagation(); fn(sub); };
  const onKey = (e) => {
    if (e.target === e.currentTarget && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); onOpen(sub); }
  };

  return (
    <div className="pr" data-testid={`proposal-row-${sub.id}`} tabIndex={0} role="button" aria-label={`Review ${sub.title}`}
      onClick={() => onOpen(sub)} onKeyDown={onKey}>
      <CategoryTile category={sub.category} />
      <div>
        <div className="ttl"><b>{sub.title}</b><span className="mono">#{sub.id}</span><CategoryTag category={sub.category} /></div>
        <div className="meta">
          <span><Icon n="cal" s={13} />Submitted {formatDate(sub.submittedAt)}</span>
          {sub.totalHours ? <span><Icon n="clock" s={13} />{sub.totalHours} hrs</span> : null}
        </div>
        <Track sub={sub} />
        {status === "rejected" && sub.reviewNotes && <div className="note"><b>Coordinator feedback:</b> {sub.reviewNotes}</div>}
      </div>
      <div className="rt">
        <StatusTag status={status} />
        <small>{statusCaption(sub)}</small>
        <div className="acts">
          {status === "approved" && <button type="button" className="btn btn-s btn-sm" onClick={stop(onSchedule)}><Icon n="plus" s={12} />Schedule sessions</button>}
          {status === "pending" && <button type="button" className="btn btn-dg btn-sm" onClick={stop(onWithdraw)}>Withdraw</button>}
          {(status === "rejected" || status === "cancelled") && <button type="button" className="btn btn-o btn-sm" onClick={stop(onRevise)}>Revise and resubmit</button>}
          <button type="button" className="btn btn-o btn-sm" onClick={stop(onOpen)}>View</button>
        </div>
      </div>
    </div>
  );
}
